import {createContext,useState,useCallback,useContext,useRef} from 'react'

const ToastContext=createContext(null)

export function ToastProvider({children}) {
    const [toasts,setToasts]=useState([])
    const idRef=useRef(0)

    const addToast=useCallback((message,type='error',duration=5000) => {
        const id=++idRef.current
        setToasts(prev => [...prev,{id,message,type}])
        if(duration>0) {
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id!==id))
            },duration)
        }
    },[])

    const removeToast=useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id!==id))
    },[])

    const showError=useCallback((message) => addToast(message,'error',5000),[addToast])
    const showSuccess=useCallback((message) => addToast(message,'success',3000),[addToast])
    const showWarning=useCallback((message) => addToast(message,'warning',4000),[addToast])
    const showInfo=useCallback((message) => addToast(message,'info',3000),[addToast])

    return (
        <ToastContext.Provider value={{toasts,addToast,removeToast,showError,showSuccess,showWarning,showInfo}}>
            {children}
        </ToastContext.Provider>
    )
}

export function useToast() {
    const ctx=useContext(ToastContext)
    if(!ctx) throw new Error('useToast must be used within ToastProvider')
    return ctx
}

export default ToastContext
